/**
 * @module modules/triage2-sk
 * @description <h2><code>triage2-sk</code></h2>
 *  A custom element that allows toggling between the three
 *  Status states of triage: positive, negative, and untriaged.
 *
 * @evt change - The value of e.detail is the new triage Status value,
 *    for example "positive", or "negative".
 *
 * @attr value - The state of triage, either "positive", "negative", or
 *    "untriaged".
 *
 * @example
 *   <triage2-sk value=positive></triage2-sk>
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "TriageSk", {
    enumerable: true,
    get: function() {
        return TriageSk;
    }
});
const _html = require("lit/html.js");
const _define = require("../../../elements-sk/modules/define");
const _ElementSk = require("../../../infra-sk/modules/ElementSk");
require("../../../elements-sk/modules/icons/check-circle-icon-sk");
require("../../../elements-sk/modules/icons/cancel-icon-sk");
require("../../../elements-sk/modules/icons/help-icon-sk");
// TODO(jcgregorio) Maybe go2ts could emit isFoo guard functions?
function isStatus(value) {
    const allowed = [
        'positive',
        'negative',
        'untriaged',
        ''
    ];
    return allowed.indexOf(value) !== -1;
}
let TriageSk = class TriageSk extends _ElementSk.ElementSk {
    connectedCallback() {
        super.connectedCallback();
        this._upgradeProperty('value');
        if (!this.value) {
            this.value = 'untriaged';
        }
        this._render();
    }
    static get observedAttributes() {
        return [
            'value'
        ];
    }
    /** @prop value - The status, such as 'positive', 'negative', or 'untriaged'. */ get value() {
        const v = this.getAttribute('value') || '';
        if (isStatus(v)) {
            return v;
        }
        return 'untriaged';
    }
    set value(val) {
        this.setAttribute('value', val);
    }
    attributeChangedCallback(_name, oldValue, newValue) {
        if (oldValue !== newValue) {
            this._render();
            this.dispatchEvent(new CustomEvent('change', {
                detail: newValue,
                bubbles: true
            }));
        }
    }
    constructor(){
        super(TriageSk.template);
    }
};
(()=>{
    TriageSk._match = (a, b)=>a === b;
})();
(()=>{
    TriageSk.template = (ele)=>(0, _html.html)`
    <button
      class="positive"
      @click=${()=>ele.value = 'positive'}
      ?selected=${TriageSk._match(ele.value, 'positive')}>
      <check-circle-icon-sk title="Positive"></check-circle-icon-sk>
    </button>
    <button
      class="negative"
      @click=${()=>ele.value = 'negative'}
      ?selected=${TriageSk._match(ele.value, 'negative')}>
      <cancel-icon-sk title="Negative"></cancel-icon-sk>
    </button>
    <button
      class="untriaged"
      @click=${()=>ele.value = 'untriaged'}
      ?selected=${TriageSk._match(ele.value, 'untriaged')}>
      <help-icon-sk title="Untriaged"></help-icon-sk>
    </button>
  `;
})();
(0, _define.define)('triage2-sk', TriageSk);
